/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type PayoutApprovalItemMetadataDtoKind = typeof PayoutApprovalItemMetadataDtoKind[keyof typeof PayoutApprovalItemMetadataDtoKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutApprovalItemMetadataDtoKind = {
  payoutApproval: 'payoutApproval',
} as const;
